import { AiAPI } from "./utils";

export const aiRecognize = AiAPI("recognize");